/* eslint-disable no-irregular-whitespace */
import request from '@/utils/request'
let preBase = 'mixApi'

// 厦门国际银行白金回归礼项目-校验领取资格接口
export const check = (data) => {
  return request({
    url: `${preBase}/xibReturnGift/check`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankPromotionJhToken'),
    data,
    // hideLoading: true,
  })
}
// 厦门国际银行白金回归礼项目-领取接口
export const receive = (data) => {
  return request({
    url: `${preBase}/xibReturnGift/receive`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankPromotionJhToken'),
    data,
    // hideLoading: true,
  })
}
// 厦门国际银行白金回归礼项目-查询领取记录接口
export const queryRecord = (data) => {
  return request({
    url: `${preBase}/xibReturnGift/queryRecord`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankPromotionJhToken'),
    data,
    // hideLoading: true,
  })
}
// 厦门国际银行白金回归礼项目-查询商品库存接口
export const queryGoodsStock = (data) => {
  return request({
    url: `${preBase}/xibReturnGift/queryGoodsStock`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankPromotionJhToken'),
    data,
    // hideLoading: true,
  })
}
// 厦门国际银行白金回归礼项目-查询地区接口
export const getListRegion = (data) => {
  return request({
    url: `${preBase}/xibReturnGift/listRegion`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankPromotionJhToken'),
    data,
    // hideLoading: true,
  })
}
